module.exports = __webpack_public_path__ + "img/Sina- gray.6c3f7e8.png";